export const REGISTER_GOOGLE_SSO = '@AUTH/REGISTER_GOOGLE_SSO'
export const REGISTER_BASIC = '@AUTH/REGISTER_BASIC'
export const REGISTER_BASIC_INVITE = '@AUTH/REGISTER_BASIC_INVITE'
export const REGISTER_RESEND_EMAIL = '@AUTH/REGISTER_RESEND_EMAIL'
export const LOGIN = '@AUTH/LOGIN'
export const LOGIN_GOOGLE_SSO = '@AUTH/LOGIN_GOOGLE_SSO'
export const LOGIN_MS_SSO = '@AUTH/LOGIN_MS_SSO'
export const LOGOUT = '@AUTH/LOGOUT'
export const RESET_PASSWORD_SEND_MAIL = '@AUTH/RESET_PASSWORD_SEND_MAIL'
export const PAYMENT_REGISTER = '@AUTH/PAYMENT_REGISTER'
export const CHANGE_PASSWORD = '@AUTH/CHANGE_PASSWORD'
export const REGISTER_ENTERPRISE = '@AUTH/REGISTER_ENTERPRISE'
export const SIGN_UP_VERIFY_TOKEN = '@AUTH/SIGN_UP_VERIFY_TOKEN'
export const SET_IS_2FA = '@AUTH/SET_IS_2FA'
